module.exports = __webpack_public_path__ + "img/sudan-2.2dbe58a4.png";